import React from "react";
import PencilIcon from "icons/PencilIcon";
export default function DescriptionRow({
  itemDescription,
  setItemDescription,
}) {
  function handleDescriptionChange(event) {
    setItemDescription(event.target.value);
  }

  function handleInputKeyPress(event) {
    if (event.key === "Enter") {
      event.target.blur();
    }
  }

  return (
    <div className="Description-row item-view-row">
      <div className="pencil-icon-container">
        <PencilIcon />
      </div>
      <textArea
        value={itemDescription}
        onChange={handleDescriptionChange}
        placeholder="Write a note..."
        onKeyPress={handleInputKeyPress}
      />
    </div>
  );
}
